module.exports = __webpack_public_path__ + "static/media/stevenPicCircle.5232ea5e.png";